"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configprod = exports.configqa = void 0;

/**
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks
 * owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */
var configqa = {
  sentienceURL: 'https://imsqa.sentience.honeywell.com',
  realm: 'cbpgatqa'
};
exports.configqa = configqa;
var configprod = {
  sentienceURL: 'https://ims.sentience.honeywell.com',
  realm: 'sentgdprod'
};
exports.configprod = configprod;